<template>
  <v-row justify="center" dense>
    <v-col
      v-if="arrows"
      align-self="center"
      cols="1"
      >
      <div
        class="galleryArrow left"
        @click="index>0?click(index-1):click(items.length-1)"
      ></div>
    </v-col>
    <v-col cols="10" :sm="Math.ceil(items.length/2 )" align-self="center">
      <li class="nav-dots">
        <label v-for="(item, i) in items" :key="'list'+i" @click="click(i)" :class="(i===index) ? 'nav-dot active' : 'nav-dot' "></label>
      </li>
    </v-col>
    <v-col
      v-if="arrows"
      align-self="center"
      cols="1"
      >
      <div
        class="galleryArrow right"
        @click="index === (items.length-1) ? click(0) : click(index+1)"
      ></div>
    </v-col>
  </v-row>
</template>
<style>
  .nav-dots {
    height: 11px;
    display: block;
    text-align: center;
    margin-bottom:20px;
  }
  .nav-dots .nav-dot {
    width: 11px;
    height: 11px;
    margin: 0 4px;
    position: relative;
    border-radius: 100%;
    display: inline-block;
    background-color: #F7D05A;
    cursor: pointer;
  }
  .nav-dots .nav-dot:hover, .nav-dot.active {
    background-color: black;
  }
</style>
<style scoped>
.galleryArrow {
  border-width: 0 3px 3px 0;
  padding: 6px;
}
.galleryArrow:hover {
  border: solid black;
  border-width: 0 3px 3px 0;
}
</style>
<script>
export default {
  name: 'NavDots',
  props: {
    items: Array,
    click: Function,
    index: Number,
    arrows: Boolean
  }
}
</script>
